const CONDITION = {
  ROUGH: '1',
  USED: '2',
  GOOD: '3',
  GREAT: '4',
  EXCELLENT: '5',
  NEW: '6',
};

const ALL_LISTING_STATUS = [
  CONDITION.ROUGH,
  CONDITION.USED,
  CONDITION.GOOD,
  CONDITION.GREAT,
  CONDITION.EXCELLENT,
  CONDITION.NEW,
];

export function ConditionToLabel(condition) {
  switch (condition) {
    case CONDITION.ROUGH:
      return 'Rough';
    case CONDITION.USED:
      return 'Used';
    case CONDITION.GOOD:
      return 'Good';
    case CONDITION.GREAT:
      return 'Great';
    case CONDITION.EXCELLENT:
      return 'Excellent';
    case CONDITION.NEW:
      return 'New';
    default:
      return 'Unknown';
  }
}

export default CONDITION;
